export const delay = (timeout: number = 100) =>
  new Promise((resolve) => setTimeout(resolve, timeout));
